export default __webpack_public_path__ + "static/media/Ballroll_00101.18b0e3b7.png";